export const KALEP_ACTIONS_COLUMN_KEY = "kalep-actions-column";
